'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagDmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.01328e-06 -1.52588e-05H28C28 6.66665 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -6.53079e-06 6.66665 1.01328e-06 -1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 7.99999H28V-1.52588e-05H1.01328e-06L0 7.99999Z",
          fill: "#108753"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V12H0V20Z",
          fill: "#108753"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 20H12V12H0V7.99999H12V-1.52588e-05H16V7.99999H28V12H16V20Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6667 20H13.3333V10.6667H0V9.33332H13.3333V-1.52588e-05H14.6667V9.33332H28V10.6667H14.6667V20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3333 20H12V9.33332H0V7.99999H12V-1.52588e-05H13.3333V7.99999H28V9.33332H13.3333V20Z",
          fill: "#FCD449"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 9.99999C18.6667 7.42266 16.5773 5.33332 14 5.33332C11.4227 5.33332 9.33333 7.42266 9.33333 9.99999C9.33333 12.5773 11.4227 14.6667 14 14.6667Z",
          fill: "#E02C42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 7.33332C13.9291 7.33332 13.8591 7.33607 13.7898 7.34144C13.4228 7.36996 13.1021 7.0955 13.0735 6.72842C13.045 6.36133 13.3195 6.04063 13.6866 6.01212C13.7901 6.00407 13.8946 5.99998 14 5.99998C14.1054 5.99998 14.2099 6.00407 14.3134 6.01212C14.6805 6.04063 14.955 6.36133 14.9265 6.72842C14.8979 7.0955 14.5772 7.36996 14.2102 7.34144C14.1409 7.33607 14.0709 7.33332 14 7.33332ZM12.3419 7.03204C12.5811 7.3119 12.5482 7.73272 12.2683 7.97197C12.162 8.06288 12.0629 8.162 11.972 8.26834C11.7327 8.5482 11.3119 8.58112 11.0321 8.34187C10.7522 8.10262 10.7193 7.6818 10.9585 7.40193C11.0945 7.24282 11.2428 7.09452 11.4019 6.9585C11.6818 6.71925 12.1026 6.75217 12.3419 7.03204ZM15.6581 7.03204C15.8974 6.75217 16.3182 6.71925 16.5981 6.9585C16.7572 7.09452 16.9055 7.24282 17.0415 7.40193C17.2807 7.6818 17.2478 8.10262 16.968 8.34187C16.6881 8.58112 16.2673 8.5482 16.028 8.26834C15.9371 8.162 15.838 8.06288 15.7317 7.97197C15.4518 7.73272 15.4189 7.3119 15.6581 7.03204ZM10.7284 9.07353C11.0955 9.10205 11.37 9.42275 11.3415 9.78983C11.3361 9.85905 11.3333 9.92913 11.3333 9.99999C11.3333 10.0708 11.3361 10.1409 11.3415 10.2101C11.37 10.5772 11.0955 10.8979 10.7284 10.9264C10.3613 10.955 10.0406 10.6805 10.0121 10.3134C10.0041 10.2099 10 10.1053 10 9.99999C10 9.89463 10.0041 9.7901 10.0121 9.68656C10.0406 9.31948 10.3613 9.04502 10.7284 9.07353ZM17.2716 9.07353C17.6387 9.04502 17.9594 9.31948 17.9879 9.68656C17.9959 9.7901 18 9.89463 18 9.99999C18 10.1053 17.9959 10.2099 17.9879 10.3134C17.9594 10.6805 17.6387 10.955 17.2716 10.9264C16.9045 10.8979 16.63 10.5772 16.6585 10.2101C16.6639 10.1409 16.6667 10.0708 16.6667 9.99999C16.6667 9.92913 16.6639 9.85905 16.6585 9.78983C16.63 9.42275 16.9045 9.10205 17.2716 9.07353ZM11.0321 11.6581C11.3119 11.4188 11.7327 11.4518 11.972 11.7316C12.0629 11.838 12.162 11.9371 12.2683 12.028C12.5482 12.2672 12.5811 12.6881 12.3419 12.9679C12.1026 13.2478 11.6818 13.2807 11.4019 13.0415C11.2428 12.9054 11.0945 12.7572 10.9585 12.598C10.7193 12.3182 10.7522 11.8974 11.0321 11.6581ZM16.968 11.6581C17.2478 11.8974 17.2807 12.3182 17.0415 12.598C16.9055 12.7572 16.7572 12.9054 16.5981 13.0415C16.3182 13.2807 15.8974 13.2478 15.6581 12.9679C15.4189 12.6881 15.4518 12.2672 15.7317 12.028C15.838 11.9371 15.9371 11.838 16.028 11.7316C16.2673 11.4518 16.6881 11.4189 16.968 11.6581ZM13.0735 13.2716C13.1021 12.9045 13.4228 12.63 13.7898 12.6585C13.8591 12.6639 13.9291 12.6667 14 12.6667C14.0709 12.6667 14.1409 12.6639 14.2102 12.6585C14.5772 12.63 14.8979 12.9045 14.9265 13.2716C14.955 13.6386 14.6805 13.9593 14.3134 13.9879C14.2099 13.9959 14.1054 14 14 14C13.8946 14 13.7901 13.9959 13.6866 13.9879C13.3195 13.9593 13.045 13.6386 13.0735 13.2716Z",
          fill: "#0E673F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 11.3333C14.7364 11.3333 14.6667 10.7364 14.6667 9.99999C14.6667 9.26361 14.7364 8.66665 14 8.66665C13.2636 8.66665 13.3333 9.26361 13.3333 9.99999C13.3333 10.7364 13.2636 11.3333 14 11.3333Z",
          fill: "#0E673F"
        }
      )
    ]
  }
);
const VpFlagDmAsset = forwardRef(FlagDmAsset);

export { VpFlagDmAsset as default };
